import { render } from "./ContentLoading.vue?vue&type=template&id=6260b1e8&scoped=true"
import script from "./ContentLoading.vue?vue&type=script&lang=js"
export * from "./ContentLoading.vue?vue&type=script&lang=js"

import "./ContentLoading.vue?vue&type=style&index=0&id=6260b1e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6260b1e8"]])

export default __exports__